export default async function auth ({ to, next, store, cookie, Vue }) {
  store.commit('auth/setRedirect', to)
  // try to parse and work tha auth out with login token if present as query parameter
  if (to.query.token) {
    try {
      const params = { code: to.query.token }
      const response = await Vue.axios.post('/api/auth/login-with-authcode', params)
      if (response.data && response.data.data) {
        // set things to local session
        const session = JSON.stringify({
          token: response.data.data.token,
          user: response.data.data.user
        })
        cookie.set('session', session, { expires: '1M' })
      }
    } catch (err) {
      // continue execution as was defined before this change
      console.log(err)
    }
  }

  const session = JSON.parse(cookie.get('session'))
  if (session) {
    setAuthedUser(session.token, session.user)
  }
  // helper funcion
  function setAuthedUser (token, user) {
    store.commit('auth/setToken', token)
    store.commit('auth/setUser', user)
    if (user) {
      store.commit('auth/setLocale', user.language)
    }
    Vue.axios.defaults.headers.common.Authorization = `Bearer ${token}`
  }
  if (!store.state.auth.loggedIn) {
    return next({
      name: 'Login'
    })
  }
  return next()
}
